import { ArrowRight, Timer } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function JoinTheMovement() {
  return <section data-section-id="184914" id="begin-your-journey" className="dark bg-background text-foreground">
      <div className="grid grid-cols-1 lg:grid-cols-[45%_55%] gap-0 w-full min-h-[700px]">
        {}
        <div className="relative min-h-[50vh] lg:min-h-full bg-cover bg-center bg-muted/10">
          {}
          <div className="absolute inset-0 bg-black/20 mix-blend-multiply !bg-[url(https://stirring-mammal.10web.cloud/wp-content/uploads/2026/04/the-one-events.jpg)] !bg-[url(https://theoneomancamps.com/wp-content/uploads/2026/04/the-one-events.jpg)] !opacity-[1] !text-[hsl(0,0%,100%)] !bg-[url(https://theoneomancamps.com/wp-content/uploads/2026/04/luxury_desert_breakfast_setting.webp)] !bg-[url(https://theoneomancamps.com/wp-content/uploads/2026/04/sunset-camel-ride-at-the-one-camp.jpg)] !shadow-none" />
          {}
          <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-card to-transparent lg:hidden" />
        </div>

        {}
        <div className="flex flex-col p-8 bg-card relative overflow-hidden !justify-end !items-start sm:p-12 lg:p-20 xl:p-24">
          {}
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

          <div className="relative z-10 w-full max-w-xl mx-auto lg:mx-0">
            {}
            <Badge variant="outline" className="justify-center rounded-md border whitespace-nowrap shrink-0 [&>svg]:size-3 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground mb-8 border-primary/50 text-primary px-4 py-2 uppercase tracking-widest font-bold flex items-center gap-2 w-fit bg-primary/10 backdrop-blur-sm !font-serif !text-sm dark:aria-invalid:ring-destructive/40">EXCLUSIVE PRIVATE LUXURY EXPERIENCE – WAHIBA SANDS, OMAN</Badge>

            {}
            <h2 className="font-default font-black uppercase tracking-tighter leading-[0.85] text-foreground !text-3xl !text-center ![margin:0px_0px_32px_0px]">UNVEIL YOUR DESERT SANCTUARY</h2>

            {}
            <p className="text-muted-foreground mb-12 leading-relaxed max-w-md font-sans !text-center !font-medium !text-base">Experience the ultimate seclusion in a luxury desert camp in Oman’s Wahiba Sands. Our exclusive single-tent private camps offer a truly authentic Omani desert escape, where every detail is designed for privacy, comfort, and silence among the golden dunes.</p>

            {}
            <Button asChild size="lg" className="w-full h-20 text-xl font-default font-black uppercase tracking-[0.2em] bg-primary text-primary-foreground hover:bg-foreground hover:text-background transition-all duration-500 group rounded-none shadow-[0_0_30px_rgba(210,140,70,0.2)] hover:shadow-[0_0_40px_rgba(255,255,255,0.3)]">
              
            </Button>

            {}
            <div className="mt-8 flex items-center gap-4 text-xs font-bold uppercase tracking-widest opacity-80 !justify-center !h-[26px] text-muted-foreground !bg-transparent sm:text-sm">
              <span className="!text-justify !text-xl">COMPLETE PRIVACY</span>
              <span className="w-1.5 h-1.5 rounded-full bg-primary/50" />
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}